import { Window, WindowProps } from '@progress/kendo-react-dialogs';
import { ComponentType, useContext, useEffect, useState } from 'react';
import { Slider } from '@progress/kendo-react-inputs';
import { FluidForm } from '../../../components/forms';
import { GameDocumentContext } from '../../../contexts/game-document';
import { MapImage } from '../../../types/game-document';
import debounce from 'lodash/debounce';
import {
  GetDetailMapImageByMapImageId,
  UpdateGameDocState,
  UpdateMapImagesAsync
} from '../../../utils/game-document';
import ImageLayer from 'ol/layer/Image';
import GeoImage from 'ol-ext/source/GeoImage';

interface MapImagePropertyEditorWindowProps extends WindowProps {
  id: string;
  imageLayersRef: React.RefObject<Record<string, ImageLayer<GeoImage>>>;
  onClose?: () => void;
}

export const MapImagePropertyEditorWindow: ComponentType<
  MapImagePropertyEditorWindowProps
> = ({ ...props }: MapImagePropertyEditorWindowProps) => {
  const id = props.id;
  const selectedImage = props.imageLayersRef.current[id];
  const [state, setState] = useContext(GameDocumentContext);
  const [opacity, setOpacity] = useState<number>(
    (selectedImage ? selectedImage.getOpacity() : 1) * 100
  );

  const updateMapImageAsset = (mapImage: MapImage) => {
    UpdateMapImagesAsync(state.gameDocument!, mapImage).then((response) => {
      setState((prev) => UpdateGameDocState(prev, response));
    });
  };

  const updateOpacitySize = async (value: number) => {
    const imageId = id.replaceAll('image-', '');
    const image = await GetDetailMapImageByMapImageId(
      state?.gameDocument!,
      imageId
    );
    if (image) {
      image.opacity = value / 100;
      updateMapImageAsset(image);
    }
  };

  const updateOpacitySizeDebounced = debounce(updateOpacitySize, 500);

  return (
    <Window
      modal={true}
      resizable={false}
      minimizeButton={undefined}
      maximizeButton={undefined}
      className={'shadow'}
      initialWidth={400}
      initialHeight={200}
      style={{
        left: '65%', // This sets the element to the right side of its containing element
        top: '3%' // Adjust this value as needed to position vertically
      }}
      overlayStyle={{
        display: 'none'
      }}
      title={''}
      {...props}>
      <FluidForm>
        <div className={'d-flex flex-row'}>
          <div className={'flex-column flex-fill'}>
            <div className={'d-flex flex-column mt-3'}>
              <span>Opacity</span>
              <Slider
                className={'w-100'}
                step={25}
                value={opacity}
                min={0}
                max={100}
                onChange={(v) => {
                  props.imageLayersRef.current[props.id].setOpacity(
                    v.value / 100
                  );
                  setOpacity(v?.value);
                  updateOpacitySizeDebounced(v.value);
                }}
              />
            </div>
          </div>
        </div>
      </FluidForm>
    </Window>
  );
};
